import { ChevronRight } from "lucide-react";
import React, { ReactNode } from "react";

interface DashboardTileProps {
    title: string;
    onNavigate?: () => void;
    children?: ReactNode;
    showNavigationArrow?: boolean;  // Flag to show/hide arrow, default true
}

const DashboardTile: React.FC<DashboardTileProps> = ({ title, onNavigate, children, showNavigationArrow = true }) => {
    return (
        <div className="flex h-full flex-col p-6 rounded-lg border border-gray-300 bg-white mb-4">
            <div className="flex items-center justify-between">
                <h2 
                    className="text-xl text-blue-500 leading-none flex items-center"
                    onClick={onNavigate}
                >
                    {title}
                </h2>
                {onNavigate && showNavigationArrow && (
                    <ChevronRight 
                        className="w-7 h-7 flex-shrink-0 text-blue-500" 
                        onClick={onNavigate} 
                    />
                )}
            </div>

            <div className="mt-4 flex-1">
                {children}
            </div>
        </div>
    );
};

export default DashboardTile;
